import { gsap } from 'gsap';

import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { ScrollSmoother } from 'gsap/ScrollSmoother.js';

export default class RadarAnimation {
  constructor(element) {
    gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

    this.element = element;
    this.init();
  }

  init() {
    const triggerOptions = {
      scrub: 1,
      trigger: this.element,
      start: '20% 50%',
      end: 'bottom-=40% 50%',
    };

    gsap.to(document.querySelector('.js-radar'), {
      rotateX: 70,
      ease: 'none',
      scrollTrigger: triggerOptions,
    });

    gsap.to(document.querySelector('.js-radio'), {
      maxWidth: 200,
      ease: 'none',
      scrollTrigger: triggerOptions,
    });
    gsap.to(document.querySelector('.js-dashes'), {
      maxWidth: 1000,
      ease: 'none',
      scrollTrigger: triggerOptions,
    });

    gsap.to(document.querySelector('.js-eyes'), {
      opacity: 0.35,
      ease: 'none',
      scrollTrigger: triggerOptions,
    });
  }
}
